<template>
  <div class="p-1">
     <div-table :config="configList"  :idWharhouse="idWharhouse" :currentUser="currentUser" :data="regroupements" @reset="reset"  @refresh="refresh" @filtrer="filtrer" @search="search" :loading="loading" :paginate="paginate" @paginatation="paginatation"></div-table>
  </div>
</template>

<script>
import config from './config'
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
       configList: config.list,
       loading:false,
       content: {},
       regroupements:[],
       warehouses:[],
       limit: 10,
       paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
       },
    };
  },
  async mounted() {
   // await this.getWarehouses();
    await this.getRegroupements({ limit: this.limit });
  },

  filters: {},
  methods: {
    async getWarehouses(){
        const res = await this.$server.search("warehouses",{limit:1000});
        if (res.content.results) {
           this.warehouses = res.content.results;
        } else this.warehouses = [];
    }, 
    getElementInArray(data,value){
        var result  = data.filter(function(o){
            let whar=o._id.toString();
            return whar == value.toString();
        } );
        return result? result[0] : null; // or undefined
    },
    async getRegroupements(filters) {
      const res = await this.$server.search("regroupements", filters);
      if (res.content.results) {
        this.warehouses= this.currentUser.warehouses;
        this.regroupements = res.content.results;
         for(const element of this.regroupements) { 
            let index = 0;
             for(let warehouse  of element.warehouses) { 
                console.log('----------',warehouse)
                const wareh=this.getElementInArray(this.warehouses, warehouse)
                 element.warehouses[index]=wareh.flag;
                  index ++;
                 console.log('----------',warehouse)
             }
         }
         console.log('this.regroupements--------',this.regroupements)
        this.regroupements.total = res.content.total;
        this.regroupements.lastpage = res.content.last_page;
        this.regroupements.per_page = res.content.per_page;
        this.regroupements.currentpage = res.content.current_page;
      } else{ this.regroupements = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
    },
    async refresh() {
        this.getRegroupements({ limit: this.limit });
    },
    /*********************************************************************************/
    async reset(data) {
      const filters = {
        limit: this.limit,
      };
      await this.getRegroupements(filters);
    },
    async search(data) {
          const res = await this.$server.find("regroupements", {name: data});
          console.log('resuult',res)
          if (res.content) {
            this.regroupements = res.content;
            this.regroupements.total = res.content.total;
            this.regroupements.lastpage = res.content.last_page;
            this.regroupements.per_page = res.content.per_page;
            this.regroupements.currentpage = res.content.current_page;
          } else {this.regroupements = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
    },
    async filtrer(data) {
      console.log(data);
        await this.getRegroupements({name: data.name,limit: this.limit,});
    },
    /****************************************************************************/
    /***************************************************************************************/
    async paginatation(direction){
      var page=0;
      if(direction == "next") page=++this.paginate.currentpage;
      else page=--this.paginate.currentpage;

      this.getRegroupements({page: page,limit: this.limit});
    },
  },
};
</script>

<style>
</style>




